let setNumOnlyInput;

setNumOnlyInput = (target, maxleng, additional) => {

    // ------------------------------------------------------------ //
    // e.keyCode 목록
    // 48~57: 키보드 일반 0~9
    // 96~105: 키보드 오른쪽 숫자패드 0~9
    // 8: backspace, 9: tab, 46: delete, 13: enter,
    // 37: ArrowLeft, 38: ArrowUp, 39: ArrowRight, 40: ArrowDown
    // 299: 한글 Process
    // ------------------------------------------------------------ //

    target.addEventListener('keydown', (e) => {
        let value, isNumKey, isSelected, isNecessary;
        value = e.target.value;
        isNumKey = (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105); // 숫자인가?
        isSelected = target.selectionStart === 0 && target.selectionEnd === 2 // 선택되었는가?
        isNecessary = e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 46 || (e.keyCode >= 37 && e.keyCode <= 40); // 필수 key(backspace, 화살표 등)인가?

        if (isNumKey) {
            if (value.length >= maxleng && !isSelected) { // 길이가 maxleng 이상이고, 선택되지 않았을 경우 입력하지 않음
                e.preventDefault();
                e.target.value = value;
            }
        } else if (!isNecessary) {
            e.preventDefault();
            e.target.value = value;
        } else {
            if (additional) additional(e);
        }
    }, false);

    target.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/[\ㄱ-ㅎㅏ-ㅣ]/g, ""); // 한글 자/모일 경우 ''로 치환
    }, false);
}

export default setNumOnlyInput;